import { Card } from "antd";
import { FC } from "react";
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { addComma } from "src/utils/StringUtil";

interface Props {
  data: any[];
  loading: boolean;
}

const MainDeviceGraph: FC<Props> = ({ data, loading }) => {
  return (
    <Card
      loading={loading}
      style={{
        borderRadius: "8px",
        marginInline: "6px",
        marginBottom: "10px",
        paddingTop: "10px",
        paddingBottom: "8px",
      }}
    >
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={data}>
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" />
          <YAxis yAxisId="right" orientation="right" />
          <Tooltip
            content={({ active, payload }: any) => {
              if (active && payload?.length) {
                const play = payload.find(
                  (p: any) => p.dataKey === "playCount"
                );
                const view = payload.find(
                  (p: any) => p.dataKey === "viewCount"
                );
                const percent =
                  ((view.value / play.value) * 100).toFixed(2) + "%";

                return (
                  <div
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      padding: 10,
                    }}
                  >
                    <div>
                      <strong>{payload[0].payload.date}</strong>
                    </div>
                    {play && (
                      <div style={{ color: play.color }}>
                        재생수: {addComma(play.value)}
                      </div>
                    )}
                    {view && (
                      <div style={{ color: view.color }}>
                        시청자수: {addComma(view.value)}
                      </div>
                    )}
                    {percent && (
                      <div style={{ color: "#878787" }}>시청률: {percent}</div>
                    )}
                  </div>
                );
              }
              return null;
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="playCount"
            stroke="#8884d8"
            name="재생수"
            yAxisId="left"
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="viewCount"
            stroke="#82ca9d"
            name="시청자수"
            yAxisId="right"
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default MainDeviceGraph;
